import { ColDef } from '@ag-grid-enterprise/all-modules'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'

export const batchActionsCaseColumnDefs =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('diagnosis.grid.caseGrid.casCasenumber'),
            colId: 'casCasenumber',
            field: 'caseNumber',
            width: 150,
            minWidth: 140,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('diagnosis.batchActionsModal.caseType'),
            field: 'caseType.descriptionInLaboratory',
            width: 150,
            minWidth: 140,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.DATETIME,
            headerName: i18n.tc('diagnosis.grid.caseGrid.casRegistrationDate'),
            colId: 'casRegistrationDate',
            field: 'registrationDate',
            width: 150,
            minWidth: 140,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('diagnosis.grid.caseGrid.pathologist'),
            colId: 'pathologist.normalizedFullName',
            field: 'pathologist.fullName',
            width: 150,
            minWidth: 140,
            suppressSizeToFit: true
        }
    ]
